import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Stack } from "@mui/material";
import "../../../styles/DocumentDetails.css";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { useGetCreditNoteHandler } from "../dataHandlers/getCreditNoteHandler";
import DocumentSkeletonForm from "../../../components/DocumentSkeletonForm";
import CreditNoteForm from "../components/CreditNoteForm";

export default function CreditNoteDetailsPage({ isPurchase = false }) {
  useDocumentTitle("Credit Note Details");
  const navigate = useNavigate();
  const { document_id } = useParams();
  const { creditNote, isLoading } = useGetCreditNoteHandler(
    document_id,
    isPurchase,
  );
  const onClickBackButton = () => {
    return isPurchase
      ? navigate("purchse?tab=credit-notes")
      : navigate("/sales?tab=credit-notes");
  };

  if (isLoading || !creditNote) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: "-1rem" }}>
      <CreditNoteForm
        onSubmit={() => {}}
        onCancel={onClickBackButton}
        initialData={creditNote}
        readOnly={true}
        isPurchase={isPurchase}
      />
    </Stack>
  );
}
